import { PureComponent } from 'react'
import { Link } from 'react-router-dom';
import { Table, Row, Col, Button, Alert } from 'react-bootstrap';

import { title_evaluation_save, str_no_exams_available, linkTriggerExamLoad } from '../Consts';

export class EvaluationSave extends PureComponent {
 
    async genFileNamePickerDialog(workLoad) {
        const opts = {
            suggestedName: this.genFilename(),
            types: [{
                description: 'JSON Datei',
                accept: { 'application/json': ['.json'] },
            }],
        };

        try {
            const handle = await window.showSaveFilePicker(opts);
            const writable = await handle.createWritable();
            await writable.write(workLoad);
            await writable.close();
            this.props.backCallerSetNotice("Der aktuelle Auswertungsstand wurde unter dem Dateinamen '" + handle.name +
                "' auf Ihrem lokalen Dateisystem gespeichert.",
                "Auswertungsstand gespeichert",
                "info");
        }
        catch (err) {
            this.props.backCallerSetNotice("Der aktuelle Auswertungsstand wurde nicht gespeichert.",
                "Speichern abgebrochen",
                "warning");
            // console.log(err);
        }
    }

    handleDirectSave = () => {
        this.props.backCallerGoModal('confirm_state_save_auto_filename');
    }

    handleSave = () => {
        const saveState = {
            ...this.props.parentState,
            helper: { ...this.props.standardState.helper }
        };

        const textFile = new Blob([JSON.stringify(saveState)], { type: 'application/json' });

        if (window.showSaveFilePicker) {
            this.genFileNamePickerDialog(textFile);
        }
        else {
            this.handleDirectSave();
        }
    }

    genFilename() {
        var invalid_chars = /[^a-zA-Z0-9_-]/g;
        // const fn = new Date().toISOString().slice(0, 10) + "-Analyse" + "-" +
        //     this.props.parentState.klassenarbeiten[0].schuljahr.replace(invalid_chars, "") + "-" +
        //     this.props.parentState.klassenarbeiten[0].fach.replace(invalid_chars, "") + ".json";
        const fn = `${new Date().toISOString().slice(0, 10)}-Analyse-${this.props.parentState.klassenarbeiten[0].schuljahr.replace(invalid_chars, "")}-${this.props.parentState.klassenarbeiten[0].fach.replace(invalid_chars, "")}.json`;
        return fn;
    }

    render() {
        return (
            <>
                <h5 className="mb-3">{title_evaluation_save}</h5>

                {this.props.parentState.klassenarbeiten.length === 0 &&
                    <Alert variant="warning" className="alert-crits">
                        <h6>Hinweis: {str_no_exams_available}<br />
                            Um eine Analyseschritte durchf&uuml;hren zu k&ouml;nnen, laden Sie bitte mindestens eine
                            Klassenarbeit unter
                            &nbsp;<Link to={linkTriggerExamLoad}>
                                <Button variant="outline-primary" size="sm">
                                    Klassenarbeiten laden
                                </Button>
                            </Link>
                            &nbsp;in das System und werten Sie diese im Anschluss aus.
                        </h6>
                    </Alert>
                }

                {this.props.parentState.klassenarbeiten.length > 0 &&
                    <>
                        {this.props.parentState.klassenarbeiten.length === 1 &&
                            <h6>
                                Ihre Analyse enthält <span className="fw-bold">eine</span> Klassenarbeit.
                            </h6>}
                        {this.props.parentState.klassenarbeiten.length > 1 &&
                            <h6>
                                Ihre Analyse enthält <span className="fw-bold">{this.props.parentState.klassenarbeiten.length}</span> Klassenarbeiten.
                            </h6>}

                        <Row className="mt-3">
                            <Col>
                                <Table striped bordered hover size="sm" >
                                    <thead>
                                        <tr><th>Dateiname</th><th>Jahr</th><th>Fach</th><th>Klasse</th>
                                            <th>Sch&uuml;ler</th><th>Aufgaben</th><th>Punkte</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.parentState.klassenarbeiten.map((
                                            { schuljahr, fach, klasse, maxPunkte, grid, fileName, ...rest }, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{fileName}</td>
                                                    <td>{schuljahr}</td>
                                                    <td>{fach}</td>
                                                    <td>{klasse}</td>
                                                    <td>{grid.length}</td>
                                                    <td>{maxPunkte[0].length - 3}</td>
                                                    <td>{maxPunkte[0][maxPunkte[0].length - 1].value}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <Alert variant="info" className="alert-crits">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                className="button-hover-white me-3"
                                onClick={() => this.handleSave()}
                            >
                                Klicken Sie hier, um den aktuellen Stand der Analyse auf Ihrem lokalen Dateisystem zu speichern.
                                {/* <input id="inputFileUpload" type="file" onChange={e => this.handleFileSaveChange(e, this)} /> */}
                            </Button>
                            Sie k&ouml;nnen den aktuellen Stand Ihrer Analyse auf Ihrem lokalen
                            Dateisystem abspeichern. Zu einem beliebigen&nbsp;
                            sp&auml;teren Zeitpunkt k&ouml;nnen Sie (nat&uuml;rlich auch
                            Ihre Kolleginnen und Kollegen) diesen Analysestand erneut in das System
                            laden und weiter nutzen.

                        </Alert>
                    </>
                }
            </>
        )
    }
}
